import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';


export interface DialogData {
  idConvenio: any,
  tipoConvenioString: any,
  nombreRegion: any,
  idPlanPago: any
  archivos: any
  id: any
  monto: any
  rutUsuario: any
  nombreUsuario: any
  apellidoUsuario: any
  rol: any
  regionConvenio: any
  recarga: any
  cantidadCuota: any
  montoCuota: any
  fechacuota: any
  deshabilitado: boolean
  presionaEditar: boolean
  mostrarEditar: any
  disponiblePago: any
  idCantidadCuota: any,
  mostrarAprobarButton: any
  rutCodeudor1: any
  nombreCodeudor1: any
  apellidoCodeudor1: any
  rutCodeudor2: any
  nombreCodeudor2: any
  apellidoCodeudor2: any
  totalMaximo: any
  idUsuario: any
  tipos: any
  cuotas: any
  planes: any
  numCuota: any
  tasaInteres: any
  valorCuota: any
  region: any
  nombreCorto: any
  nombreProveedor: any
  editable: any
}

declare const Rut: any;
@Component({
  selector: 'app-pago-cuota',
  templateUrl: '../../pages/afiliacion/pago-cuota/pago-cuota.html',
  styleUrls: ['../../pages/afiliacion/pago-cuota/pago-cuota.component.css']
})
export class DialogPagoCuota implements OnInit {

  prestamos: any
  planes: any
  user: any
  rol: string = localStorage.getItem("rol")
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
  tipoPostulacion: string = "Pagadas"
  allComplete: boolean = false
  prestamoSolicitado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  nombreUsuario: any
  rutUsuario: any
  monto: any  
  fechacuota: any
  router: any
  cantidadArchivos = 1
  deshabilitado: true
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };

  pago: any = {
    id: this.data.id,
    cantidadCuotas: this.data.numCuota,
    region: this.data.nombreRegion,
    idUsuario: localStorage.getItem("idUsuario"),
    idAfiliado: this.data.idUsuario,
    tipoConvenio: this.data.tipoConvenioString,
    archivo: [], archivoTest: null,
    planes: []
  }

  constructor(public dialogRef: MatDialogRef<DialogPagoCuota>,
    public afiliacionService: AfiliacionService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog) {
    this.data.recarga = false
  }


  ngOnInit(): void { this.loadData() }

  loadData() {

  }

  pageChanged(event: any) {
    this.config.currentPage = event

    this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
    this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  salir() { this.router.navigate(['/index']) }




  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {
      // console.log(event.target.files[0].type)

      let vm = this
      let reader = new FileReader()
      this.pago.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.pago.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      }
    }
  }

  onCancelarClick() { this.dialogRef.close() }

  onAgregarPagoClick(form: NgForm) {

    let vm = this;
    if (this.pago.archivoTest == null) {
      this.openAlertDialog('Por favor, adjunte un comprobante de pago', 'btn-danger')

      Swal.close();
      return false
    } else {
      const dialogRef = this.dialog.open(ConfirmationDialog,
        {
          data: { message: '¿Esta seguro de Ingresar un comprobante de pago?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {

        if (confirmed) {
          Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
          });
          Swal.showLoading();
       
          let sizeArchivos = 0;
          for (let i = 0; i < this.cantidadArchivos; i++) {
            sizeArchivos += this.pago.archivo[i].size;
            if (sizeArchivos > 25000000) {
              this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-danger')
              Swal.close();
              return;
            }
            this.pago.archivo[i].sizeArchivos;
            if (this.pago.archivo[i].extension != "application/pdf" && this.pago.archivo[i].extension != "image/jpeg" &&
              this.pago.archivo[i].extension != "image/jpg" && this.pago.archivo[i].extension != "image/png") {
              this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-danger')

              Swal.close();
              return false
            }

          }
         
          this.afiliacionService.ingresarPago(localStorage.getItem("idUsuario"), this.pago).then(
            () => {             
              this.pago.archivo = [];
              this.openAlertDialog('La solicitud de pago de cuota fue ingresada exitosamente, aún debe ser validado.', 'btn-success')
              form.reset();          
              this.dialogRef.close()
              Swal.close();
            }
          )
            .catch(error => {
              console.log(error.status)
              if (error.status == 500) {
                this.openAlertDialog(error.error.message, 'btn-danger')
                Swal.close();
              }else{              
                this.openAlertDialog('Ha ocurrido un error al ingresar un pago.', 'btn-danger')
                Swal.close();
              }           
            })
        }
      })
    }
  }
}